module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = url
// module chunks = 0